export const globalSearch = {
    tenant: {
        "aptReportLink": "{{buildingTitle}} דירה {{apartmentNum}}",
    },
    "noResults": "אין תוצאות"
}
